import { useCallback, useEffect, useState } from 'preact/hooks';
import { Marked } from 'marked';

export type MarkdownTextProps = {
    text: string;
    linkTexts?: {
        matchingText: string;
        id: string;
        className?: string;
    }[];
    onClick?: (id: string) => void;
};

const MarkdownText = ({ text, linkTexts, onClick }: MarkdownTextProps) => {
    const [html, setHtml] = useState('');

    const wrapProductNames = useCallback(
        (text: string) => {
            (linkTexts ?? []).forEach(
                ({ matchingText, id, className = '' }) => {
                    const x = document.createElement('p');
                    x.textContent = matchingText;
                    text = text.replaceAll(
                        x.innerHTML,
                        `<a href="javascript:;" class="bri-MarkdownText-link ${className}" data-link-id="${id}">${x.innerHTML}</a>`
                    );
                }
            );
            return text;
        },
        [linkTexts]
    );

    const onTextClick = useCallback(
        (event: MouseEvent) => {
            const target = event.target as HTMLAnchorElement;
            if (target.dataset.linkId && onClick) {
                onClick(target.dataset.linkId);
            }
        },
        [onClick]
    );

    useEffect(() => {
        const marked = new Marked({ async: false });
        marked.use({
            renderer: {
                strong(text: string) {
                    return `<strong>${wrapProductNames(text)}</strong>`;
                },
                text(text: string) {
                    return wrapProductNames(text);
                }
            }
        });
        setHtml(marked.parse(text) as string);
    }, [wrapProductNames, text]);

    return (
        <div
            dangerouslySetInnerHTML={{
                __html: html
            }}
            onClick={onTextClick}
        />
    );
};

export default MarkdownText;
